var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn btn-primary",attrs:{"disabled":_vm.updating},on:{"click":_vm.update}},[_vm._v(" "+_vm._s(_vm.$t('external_pos.refresh_pos_inventory'))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }